import { TableConfigV2 } from 'hooks/useMuiTableBuilderV2';
import { HeaderCell } from 'components/Cells/HeaderCell';
import { columns, COLUMNS } from './columns';
import MembersV2CheckboxCell from './DataCells/MembersV2CheckboxCell';
import MembersV2TextCell from './DataCells/MembersV2TextCell';
import MembersV2ImpersonateCell from './DataCells/MembersV2ImpersonateCell';
import MembersV2CheckboxHeaderCell from './HeaderCells/MembersV2CheckboxHeaderCell';
import MembersV2StatusCell from './DataCells/MembersV2StatusCell';
import MembersV2ExpandToggleCell from './DataCells/MembersV2ExpandToggleCell';
import MembersV2DetailsRowCell from './DataCells/MembersV2DetailsRowCell';
import { EmptyCell } from 'components/Cells/EmptyCell';
import { ROW_TYPES } from './constants';

export const getTableConfig = (): TableConfigV2 => {
  return {
    hasStickyHeader: true,
    tableHeaderTitle: '',
    rowTypes: ROW_TYPES,
    hideToolbar: false,
    columns,
    columnsMinWidth: {
      [COLUMNS.CHECKBOX]: 40,
      [COLUMNS.TEAM_ID]: 120,
      [COLUMNS.NAME]: 220,
      [COLUMNS.EXPAND]: 40,
    },
    cellsByRowTypesAndColumns: {
      [ROW_TYPES.DATA]: {
        [COLUMNS.CHECKBOX]: MembersV2CheckboxCell,
        [COLUMNS.STATUS]: MembersV2StatusCell,
        [COLUMNS.TEAM_ID]: MembersV2TextCell,
        [COLUMNS.NAME]: MembersV2TextCell,
        [COLUMNS.TENANT]: MembersV2TextCell,
        [COLUMNS.REALM]: MembersV2TextCell,
        [COLUMNS.EMAIL]: MembersV2TextCell,
        [COLUMNS.IMPERSONATE]: MembersV2ImpersonateCell,
        [COLUMNS.EXPAND]: MembersV2ExpandToggleCell,
      },
      [ROW_TYPES.HEADER]: {
        [COLUMNS.CHECKBOX]: MembersV2CheckboxHeaderCell,
        [COLUMNS.STATUS]: HeaderCell,
        [COLUMNS.TEAM_ID]: HeaderCell,
        [COLUMNS.NAME]: HeaderCell,
        [COLUMNS.TENANT]: HeaderCell,
        [COLUMNS.REALM]: HeaderCell,
        [COLUMNS.EMAIL]: HeaderCell,
        [COLUMNS.IMPERSONATE]: HeaderCell,
        [COLUMNS.EXPAND]: HeaderCell,
      },
      [ROW_TYPES.DETAILS]: {
        [COLUMNS.CHECKBOX]: MembersV2DetailsRowCell,
        [COLUMNS.STATUS]: EmptyCell,
        [COLUMNS.TEAM_ID]: EmptyCell,
        [COLUMNS.NAME]: EmptyCell,
        [COLUMNS.TENANT]: EmptyCell,
        [COLUMNS.REALM]: EmptyCell,
        [COLUMNS.EMAIL]: EmptyCell,
        [COLUMNS.IMPERSONATE]: EmptyCell,
        [COLUMNS.EXPAND]: EmptyCell,
      },
    },
  };
};

export default getTableConfig;
